<template>
    <div>
        <v-row>
            <v-col>
                <v-menu ref="menu1" v-model="fechas.menu1" :close-on-content-click="true" transition="scale-transition" offset-y min-width="auto">
                    <template v-slot:activator="{ on, attrs }">
                        <v-text-field v-model="computedDateFormatted" label="Desde cuando:" prepend-icon="mdi-calendar" hide-details dense readonly v-bind="attrs" v-on="on"></v-text-field>
                    </template>
                    <v-date-picker v-model="fechas.date1" no-title scrollable> </v-date-picker>
                </v-menu>
            </v-col>
            <v-col>
                <v-menu ref="menu2" v-model="fechas.menu2" :close-on-content-click="true" transition="scale-transition" offset-y min-width="auto">
                    <template v-slot:activator="{ on, attrs }">
                        <v-text-field v-model="computedDateFormatted2" label="Hasta cuando:" prepend-icon="mdi-calendar" hide-details dense readonly v-bind="attrs" v-on="on"></v-text-field>
                    </template>
                    <v-date-picker v-model="fechas.date2" no-title scrollable> </v-date-picker>
                </v-menu>
            </v-col>
        </v-row>
    </div>
</template>

<script>
export default {
    data(vm) {
        return {
            fechas: {
                menu1: false,
                date1: new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10),
                menu2: false,
                date2: null,
                dateFormatted: vm.formatDate(new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10)),
            },
        };
    },
    watch: {},
    components: {},
    computed: {
        computedDateFormatted() {
            return this.formatDate(this.fechas.date1);
        },
        computedDateFormatted2() {
            return this.formatDate(this.fechas.date2);
        },
    },
    methods: {
        load() {
            this.fechas.menu1 = false;
            this.fechas.menu2 = false;
            this.fechas.date1 = null;
            this.fechas.date2 = null;
        },
        getfechainicio() {
            let f = this.formatDatetoServer(this.fechas.date1);
            //if (f) return f.replace(/\//g, "-");
            return f;
        },
        getfechafin() {
            let f = this.formatDatetoServer(this.fechas.date2);
            //if (f) return f.replace(/\//g, "-");
            return f;
        },
        formatDatetoServer(date) { 
            if (!date) return null;

            const [year, month, day] = date.split("-");
            return `${year}-${month}-${day}`;
        },

        formatDate(date) {
            if (!date) return null;

            const [year, month, day] = date.split("-");
            return `${day}/${month}/${year}`;
        },
        parseDate(date) {
            if (!date) return null;

            const [day, month, year] = date.split("/");
            return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
        },
    },
    mounted() {},
};
</script>
